import React, { Component } from 'react'
import Pdf from '../media/resume.pdf'


class Resume extends Component {

    _onClick = () => {
        window.open(Pdf)
    }

    render() {
        return (
            <div className='level'>
                <div className='level-right level-item'>
                    <button className = 'button' onClick={this._onClick}>
                        <span className='icon'><i className='far fa-file-alt'></i></span>
                        <span>Resume</span>
                    </button>
                </div>
            </div>
        )
    }

}


export default Resume



// WEBPACK FOOTER //
// ./src/components/resume.js